// Logout modal: scope choice (this device / all devices). Confirming calls
// the API's /frm/auth/logout (idempotent; 'all' kills every session of the
// user) and goes STRAIGHT to the login page — an explicit logout is a
// deliberate exit, so no return target and nothing in the URL survives it
// (upper request #26); the confirmation toast crosses via sessionStorage.
export function initLogout() {
	const modalEl = document.getElementById('logoutModal');

	// The user dropdown uses auto-close="outside", so close it manually when the
	// logout modal opens (otherwise it stays open behind the backdrop).
	if (modalEl && window.bootstrap) {
		modalEl.addEventListener('show.bs.modal', () => {
			const toggle = document.querySelector('.topbar-user[data-bs-toggle="dropdown"]');
			if (toggle) {
				const dd = window.bootstrap.Dropdown.getInstance(toggle);
				if (dd) dd.hide();
			}
		});
	}

	document.querySelectorAll('[data-logout-confirm]').forEach((btn) => {
		// g.action: one logout per click, the button busy until the page leaves
		btn.addEventListener('click', (e) => {
			const doLogout = async () => {
				const scope = (document.querySelector('input[name="logoutScope"]:checked') || {}).value || 'this';
				// the OIDC client mode (oidc.md "Signing out" — Google-style):
				// the API's identity road ends the local session(s) AND the
				// identity provider's session of this browser, then lands on
				// /login?signedout=1
				if (btn.dataset.identityLogout) {
					const target = new URL(btn.dataset.identityLogout, window.location.href);
					if (scope === 'all') target.searchParams.set('everywhere', '1');
					window.location.href = target.href;
					return;
				}
				let receipt = null;
				if (window.g && window.g.fetch) {
					const out = await window.g.fetch('/frm/auth/logout', { everywhere: scope === 'all' });
					// a failed logout is reported and the page stays: claiming
					// "signed out" over a live login ('all devices'!) would lie
					// (false = no navigation follows: g.action frees the button)
					if (!window.g.outcome(out)) return false;
					// an identity provider's sign-out told the apps that use it:
					// the login page shows their delivery state (oidc.md
					// "Delivery feedback")
					receipt = out && out.data && out.data.receipt ? out.data.receipt : null;
				}
				const login = btn.dataset.loginUrl;
				if (login) {
					try {
						sessionStorage.setItem('genus-logged-out', '1');
						if (receipt) sessionStorage.setItem('genus-logout-receipt', receipt);
					} catch { /* storage may be blocked */ }
					window.location.href = login;
				} else {
					window.location.reload(); // no login page declared — anonymous reload
				}
			};
			return window.g && window.g.action ? window.g.action(e.currentTarget, doLogout, { navigate: true }) : doLogout();
		});
	});
}
